import { createContext, useContext, useMemo } from 'react';
import type { QueryKey } from 'react-query';

export type PaneContextValue = {
  refetchQueryKey: QueryKey;
};

const PaneContext = createContext<PaneContextValue>({
  refetchQueryKey: '',
});

export const usePaneContext = () => {
  const context = useContext(PaneContext);
  if (!context) {
    throw new Error('usePaneContext must be used within PaneContextProvider');
  }
  return context;
};

export const PaneContextProvider = ({
  children,
  refetchQueryKey,
}: React.PropsWithChildren<PaneContextValue>) => {
  const contextValue = useMemo(() => ({ refetchQueryKey }), [refetchQueryKey]);
  return (
    <PaneContext.Provider value={contextValue}>{children}</PaneContext.Provider>
  );
};
